import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpUtils } from "../utils/httpUtils";

@Injectable({
  providedIn: 'root'
})
export class ReportGenerationJobsService {

  protected readonly url = environment.airUrl + '/reportGenerationJobs';

  constructor(private http: HttpClient) {
  }

  existsFinishedByIdDocument(idDocument: number): Observable<any> {
    return this.http.get(`${this.url}/existsFinished/${idDocument}`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}